import { useEffect, useState } from 'react';
import { getExtensionUnits } from '../../services/calculator/getExtensionUnitsService.js';

export const useExtensionUnits = () => {
    const [extensionUnits, setExtensionUnits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const loadExtensionUnits = async () => {
            try {
                const data = await getExtensionUnits();
                setExtensionUnits(data);
            } catch {
                setError('Error cargando las medidas de extensión.');
            } finally {
                setLoading(false);
            }
        };

        loadExtensionUnits();
    }, []);

    return {
        extensionUnits,
        loading,
        error
    };
}